module.exports = __webpack_public_path__ + "img/granada2.40433964.jpg";